import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
const $ = Backbone.$;
import Tools from '../../../services/Tools';
var platform = require('platform');
var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    return `<div class="alert_tone mf"></div>`;
  },

  initialize(o) {
    _.bindAll(
      this,
      'renderContent',
      'handleConversationClick',
      'handleAlertToneClick'
    );
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  handleConversationClick() {
    this.model.trigger('conversationClick');
  },

  handleAlertToneClick() {
    const ringtone = Tools.getRingtone(this.conf.domain_id);
    if (!ringtone) {
      Tools.setRingtone(this.conf.domain_id, 1, 30);
      this.conf.ringtone = 1;
    } else {
      Tools.setRingtone(this.conf.domain_id, 0, 30);
      this.conf.ringtone = 0;
    }
    this.model.trigger('ringtone');
  },

  renderContent() {
    const { $el } = this;
    $el.html(this.template());
    const alertEl = $el.find('.alert_tone');
    const ringtone = Tools.getRingtone(this.conf.domain_id);
    if (!ringtone) {
      alertEl.append(`<img src="${this.conf.domain}img/mute.svg">`);
      alertEl.append('Tắt âm thanh thông báo');
    } else {
      alertEl.append(`<img src="${this.conf.domain}img/unmute.svg">`);
      alertEl.append('Bật âm thanh thông báo');
    }
    // $el.find('.view_end').on('click', this.handleConversationClick);
    alertEl.on('click', this.handleAlertToneClick);
  },

  render() {
    const { $el, model } = this;
    $el.attr({ class: `${this.pfx}mySetting`, id: 'mySetting' });
    this.renderContent();
    return this;
  }
});
